import { ApiError } from '@gorila-shared-ui/components';
import { Client } from '../types/client';
import { CurrentState } from '../types/currentState';
import { getRequest } from './api';
import { clientUrl } from './urls/clientUrls';
import { currentStateUrl, publicCurrentStateUrl } from './urls/currentStateUrls';

export const getClient = async (clientId: string): Promise<{ client?: Client; error?: ApiError }> => {
  const response = await getRequest(clientUrl(clientId));
  return {
    client: response?.data,
    error: response?.error,
  };
};

export const getCurrentStates = async (
  clientId: string,
  subClientId?: string,
): Promise<{ currentStates?: CurrentState[]; error?: ApiError }> => {
  const response = await getRequest(currentStateUrl, { queryParams: { clientId, subClientId } });
  return {
    currentStates: response?.data,
    error: response?.error,
  };
};

export const getPublicCurrentStates = async (
  shareLinkId: string,
): Promise<{ currentStates?: CurrentState[]; error?: ApiError }> => {
  const response = await getRequest(publicCurrentStateUrl(shareLinkId));
  return {
    currentStates: response?.data,
    error: response?.error,
  };
};
